import {inject, provideAppInitializer, provideZoneChangeDetection} from '@angular/core';
import {provideNamedApollo} from 'apollo-angular';
import {provideHttpClient} from '@angular/common/http';
import {apolloClientFactory} from '@shared/factory/apollo-client.factory';
import {AppInitService} from './app.initializer';
import {TitleStrategy} from '@angular/router';
import {TemplatePageTitleStrategy} from '@shared/strategies/template-page-title.strategy';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import Aura from '@primeng/themes/aura';

import {ToastService} from './toast.service';
import {MessageService} from 'primeng/api';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {environment} from '../../../environments/environment';
import {getMessaging, provideMessaging} from '@angular/fire/messaging';
import {provideCacheableAnimationLoader, provideLottieOptions} from 'ngx-lottie';
import player from 'lottie-web';

export function appInitializerFactory(appInitService: AppInitService): () => Promise<void> {
  return () => appInitService.initializeApp();
}

export const appProviders = [
  provideAnimationsAsync(),
  providePrimeNG({
    theme: {
      preset: Aura,
      options: {
        prefix: 'p',
        darkModeSelector: 'light',
        cssLayer: false
      }
    }
  }),
  provideAppInitializer(() => {
        const initializerFn = (appInitializerFactory)(inject(AppInitService));
        return initializerFn();
      }),
  provideHttpClient(),
  provideLottieOptions({ player: () => player }),
  provideCacheableAnimationLoader(),
  provideNamedApollo(apolloClientFactory),
  provideZoneChangeDetection({eventCoalescing: true}),
  {
    provide: TitleStrategy,
    useClass: TemplatePageTitleStrategy
  },
  MessageService,
  ToastService,
  provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
  provideMessaging(() => getMessaging())
];
